











import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  name: 'leftCarousel'
})
export default class leftCarousel extends Vue {
  @Prop({ type: Array }) newsList: any
}
